/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'dva';
import GeneralSituation from './components/generalSituation';
import BarEcharts from './components/barEcharts';
import TableList from './components/tableList';
import ListSearch from './components/listSearch'


@connect(({ dutyArea }) => ({
  ...dutyArea,
}))


class DutyArea extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'dutyArea/fetchDutyAreaOverview',
    });
    dispatch({
      type: 'dutyArea/fetchDutyAreaCondition',
    }).then(data => {
      if (data && data[0]) {
        this.getTableLlist(data[0], 0)
      }
    })
  }

  getTableLlist = (data, page) => {
    const { dispatch } = this.props;
    const { id } = data;
    dispatch({
      type: 'dutyArea/save',
      payload: {
        currentCondition: data,
        tableLoading: true
      }
    });
    dispatch({
      type: 'dutyArea/fetchTableLlist',
      params: {
        groupId: id,
        page
      }
    });
  }

  onSearch = data => {
    const { status } = data;
    const { conditionList } = this.props;
    const filterData = conditionList.filter(item => item.id == status)
    this.getTableLlist(filterData[0], 0)
  }

  handleReset = () => {
    const { conditionList } = this.props;
    this.getTableLlist(conditionList[0], 0)
  }

  render() {
    const { personsList = [], schoolsList = [], conditionList = [] } = this.props;
    return (
      <>
        <div className='publicity'>
          <GeneralSituation data={personsList} title='责任区督学统计概况' />
          {
            !!schoolsList.length && <BarEcharts title='责任区学校数量统计' data={schoolsList} />
          }
        </div>
        <ListSearch statusList={conditionList} onSearch={this.onSearch} handleReset={this.handleReset} />
        <TableList />
      </>
    );
  }
}

export default DutyArea
